export default __webpack_public_path__ + "static/media/rank-4.1f77df93.webp";